import Vue from 'vue';
import moment from 'moment';

// 添加到 Vue原型链
Vue.prototype.$moment = moment;



// WEBPACK FOOTER //
// ./src/assets/js/$moment.js